// C:\PreventaWeb\FrontEnd\src\components\Login.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';
import useConfiguracion from '../hooks/useConfiguracion'; // ✅ Importar el nuevo hook

const Login = () => {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    
    // ✅ Obtener configuración de la empresa
    const { configuracion, loading } = useConfiguracion();

    const handleSubmitLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            console.log("Intentando login...");
            const res = await API.post('/auth/login', { usuario, password });

            localStorage.setItem('token', res.data.token);
            localStorage.setItem('usuario', JSON.stringify(res.data.usuario));

            console.log("Login exitoso, guardando token y redirigiendo...");
            console.log("Token guardado:", res.data.token);
            console.log("Usuario guardado:", res.data.usuario);

            console.log("Ejecutando navigate('/pedido')...");
            navigate('/pedido');
            console.log("Después de navigate('/pedido')");
        } catch (err) {
            console.error("Error de login:", err);
            setError('Usuario o contraseña incorrectos');
        }
    };

    return (
        <div style={{ padding: '2rem', maxWidth: '400px', margin: 'auto', fontFamily: 'Arial' }}>
            {/* ✅ Mostrar nombre de la empresa SOLO si existe */}
            {configuracion.NombreEmpresa && !loading && (
                <div style={{ 
                    textAlign: 'center', 
                    marginBottom: '1.5rem',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    color: '#007bff'
                }}>
                    {configuracion.NombreEmpresa}
                </div>
            )}
            
            <h2>🔐 Iniciar Sesión</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmitLogin}>
                <input
                    type="text"
                    placeholder="Usuario"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    required
                    style={{ display: 'block', width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
                />
                <input
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{ display: 'block', width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
                />
                <button type="submit" style={{ padding: '0.5rem 1rem', width: '100%' }}>
                    Ingresar
                </button>
            </form>
        </div>
    );
};

export default Login;